import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import ProjectFormPopup from 'views/Inventory/Project/ProjectFormPopup';
import CustomSelect from './CustomSelect';
import { useActiveUserContext } from 'contexts/ActiveUserContext';
import { Button } from 'antd';
import Vocabulary from './Vocabulary';
import ModalUtil from 'utils/modalUtil';
import ProjectAPI from 'restAPI/ProjectAPI';

const ProjectSelectWithAddButtonV2 = ({ showAddButton, onCreate, apiParams, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [armorcodeProjects, setArmorcodeProjects] = useState();

  const activeUser = useActiveUserContext();

  useEffect(() => {
    const { promise, cancel } = ProjectAPI.v2.getAll();
    promise.then((res) => {
      setArmorcodeProjects(res.map(option => ({ label: option.name, value: option.id })));
    }, _.noop);
    return cancel;
  }, []);

  const onButtonClick = useCallback(() => {
    setOpen(false);

    ModalUtil.show({
      content: <ProjectFormPopup activeUser={activeUser} />,
      afterClose: (createdProject) => {
        if (createdProject) {
          setTimeout(() => {
            const projects = armorcodeProjects || [];
            const updatedProjects = [{ label: createdProject.name, value: createdProject.id }, ...projects];
            setArmorcodeProjects(updatedProjects);
            onCreate(createdProject);
          }, [500]);
        }
      }
    });
  }, [activeUser, armorcodeProjects, onCreate]);

  return (
    <>
      <CustomSelect
        {...rest}
        style={{ width: "56%" }}
        open={open}
        onDropdownVisibleChange={setOpen}
        placeholder={<>Select <Vocabulary name={"project"} /></>}
        loading={_.isNull(armorcodeProjects)}
        options={armorcodeProjects}
      />
      <Button style={{ width: "40%", float: 'right' }} name={'project'} block onClick={onButtonClick}><>Add <Vocabulary name={"project"} /></></Button>
    </>
  )
}

export default ProjectSelectWithAddButtonV2;
